import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDidMount, useWillUnmount } from 'rooks';
import { Button, CustomScrollbars, FixedButtons, Icon, ModuleTopBar } from '../../components';
import {
	closeModules,
	collapseFilterSections,
	resetFilterTopics,
	setFilters,
	toggleFilterSections,
} from '../../redux/actions';
import colors from '../../utils/colors';
import Classes from './sections/Classes';
import Levels from './sections/Levels';
import Subjects from './sections/Subjects';
import Topics from './sections/Topics';
import './style.scss';

function FilterModule() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	const filter = state.filter;

	const scrollbarsRef = useRef(null);

	useDidMount(() => {
		if (state.editor.test['wybrane_filtry']) {
			dispatch(setFilters(state.editor.test['wybrane_filtry']));
			dispatch(collapseFilterSections());
		} else {
			dispatch(setFilters({ level: null, classes: [], subjects: [], topics: [] }));
			dispatch(collapseFilterSections());
			dispatch(toggleFilterSections('levels'));

			//difficulty and taskType to be added later
			// dispatch(setFilters({ level: 1, classes: [], subjects: [], topics: [], taskType: 3, difficulty: ["1"] }));
		}
	});

	useWillUnmount(() => {
		dispatch(setFilters({ level: null, classes: [], subjects: [], topics: [] }));
		dispatch(resetFilterTopics());

		//difficulty and taskType to be added later
		// dispatch(setFilters({ level: 1, classes: [], subjects: [], topics: [], taskType: 3, difficulty: ["1"] }));
	});

	return (
		<section className={`module-filter ${filter.mobileActive ? 'mobile-active' : ''}`}>
			<ModuleTopBar>
				<span>Filtruj zadania</span>
			</ModuleTopBar>
			<div className="filter-scrollable-fields">
				<CustomScrollbars style={{ width: '100%', height: '100%' }} autoHide refa={scrollbarsRef}>
					<Levels />
					<Classes />
					<Subjects />
					<Topics />
					{/* <TaskTypes /> */}
					{/* <Difficulty /> */}
				</CustomScrollbars>
			</div>
			{filter.mobileActive && (
				<FixedButtons>
					<Button color="primary text-white" onClick={() => dispatch(closeModules())}>
						filtruj zadania
						<Icon name="filter" width="15" height="15" color={colors.white} />
					</Button>
				</FixedButtons>
			)}
		</section>
	);
}

export default FilterModule;
